import { keys } from '@classic/Foundation/Analytics/AnalyticsDataLayer'
import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'

export const trackSideMenuItemClick = (item: string) =>
  trackEvent(keys.hamburgerMenuClicked, { item })
